<div [class.hidden]="!show" class="wrapper">
  <div class="inner">
    <mat-spinner *ngIf="show && !getUrl"></mat-spinner>
  </div>
</div>